import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Grid, Slide, Snackbar, Typography, Link } from "@mui/material";
import { useAuth } from "../helpers/AuthProvider";
import { useNavigate } from "react-router-dom";
//import { Link } from 'react-router-dom';
const LoginPage: React.FC = () => {
	const { user, loginUser } = useAuth();
	const [openDialogue, setOpenDialogue] = useState(false);
	const navigate = useNavigate();
	useEffect(() => {
		(async () => {
			try {
				const isLoggedIn: string = await loginUser();
				if (isLoggedIn == "success") {
					window.history.replaceState({}, document.title, window.location.pathname);
					navigate("/overview");
					return;
				} else if (isLoggedIn == "fail") {
					window.history.replaceState({}, document.title, window.location.pathname);
					setOpenDialogue(true);
					// navigate("/login");
				}
			} catch (error) {
				console.log(error);
				navigate("/login");
			}
		})();
	}, []);
	const handleClick = async () => {
		try {
			// window.location.href = `${process.env.REACT_APP_HOST_DOMAIN}/api/auth/google`;
			window.open(`${process.env.REACT_APP_HOST_DOMAIN}/api/auth/google`, "_self");
		} catch (error) {
			console.error("Error during login:", error);
		}
	};
	const handleClose = (event: React.SyntheticEvent | Event, reason?: any) => {
		if (reason === "clickaway") {
			return;
		}

		setOpenDialogue(false);
	};

	return (
		<Grid container sx={{ height: "100vh", bgcolor: "#2C2C2C", position: "relative" }}>
			<Snackbar
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				open={openDialogue}
				autoHideDuration={6000}
				onClose={handleClose}
				TransitionComponent={(props) => <Slide {...props} direction="down" />}
				sx={{
					cursor: "pointer",
				}}
			>
				<Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: "100%" }}>
					{/* [401 Unauthorized]  */}
					Unauthorized user 
				</Alert>
			</Snackbar>
			<Box />
			<Grid
				item
				xs={12}
				md={6}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					bgcolor: "#101010",
					color: "white",
					position: "relative",
					backgroundImage: "url(/assets/Star.svg)",
					backgroundRepeat: "no-repeat",
				}}
			>
				<Link href="/" aria-label="Go to homepage"> {/* Use the 'to' prop instead of 'href' */}
					{/* <img
					src="/assets/favicon-white.png"
					alt="Logo Icon"
					style={{
						position: "absolute",
						top: "23px",
						left: "25px",
						width: "44px",
						height: "44px",
					}}
				/> */}
					<img
						src="/assets/intellicore-transparent-white.png"
						alt="Logo Icon"
						style={{
							position: "absolute",
							top: "40px",
							left: "32px",
							width: "125px",
							height: "27px",
							display: "block",
						}}
					/>
				</Link>
				
				<Box textAlign="center">
					<Link href="/" aria-label="Go to homepage">
					<img
						src="/assets/sheild-icon.svg"
						alt="Shield Icon"
						style={{ width: "250px", marginBottom: "20px"}}
					/>
					</Link>
					{/* <img
						src="/assets/sheild-icon.svg"
						alt="Shield Icon"
						style={{ width: "250px", marginBottom: "20px" }}
					/> */}
					<Typography fontFamily="Gilroy-Bold" fontSize="36px">
						Internal Developer Platform
					</Typography>
					<Typography fontSize="19px"  sx={{ mt: 2, mx: 4}} color="#ffffff80">
					Empowering Developer Productivity, Enhancing Operational Efficiency, Ensuring Compliance.
					</Typography>
				</Box>
			</Grid>

			<Grid
				item
				xs={12}
				md={6}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					bgcolor: "#FFF",
				}}
			>
				<Box textAlign="left">
					<img
						src="/assets/key.svg"
						alt="Key Icon"
						style={{
							width: "24px",
							marginBottom: "20px",
							backgroundColor: "#F4F4F4",
							padding: "12px",
							borderRadius: "8px",
						}}
					/>
					<Typography fontFamily="Gilroy-SemiBold" fontSize="26px" sx={{ mb: 2 }}>
						Login to get started
					</Typography>
					<Typography fontFamily="Gilroy-Regular" fontSize="16px" sx={{ mb: 3 }}>
						Quick and hassle-free login, just login with your Google account and get started.
					</Typography>
					<Button
						variant="contained"
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							bgcolor: "#000",
							color: "#fff",
							textTransform: "none",
							"&:hover": { bgcolor: "#333" },
							px: 5,
							py: 1,
							position: "relative",
						}}
						fullWidth
						onClick={handleClick} // Call handleClick on button click
					>
						<Box
							sx={{
								position: "absolute",
								left: "1px",
								top: "1px",
								bgcolor: "#fff",
								borderRadius: "2px",
								height: "24px",
								padding: "6px",
								paddingBottom: "4px",
								alignItems: "center",
							}}
						>
							<img
								src="/assets/key-icon.svg"
								alt="Key Icon"
								style={{ width: "20px", height: "20px" }}
							/>
						</Box>
						<Typography fontFamily="Gilroy-Bold" fontSize="14px">
							Continue with Google
						</Typography>
					</Button>
					<Typography fontFamily="Gilroy-Regular" fontSize="16px" sx={{ mt: 3 }}>
						Don't have an account yet?
						<Link href="https://forms.gle/dvcoK8kgTUpT8FB6A"
          target="_blank" // Uncomment if you want it to open in a new tab
          // rel="noopener noreferrer" // Good practice if using target="_blank"
          underline="always" // Ensures it looks like a link within the Alert
          color="inherit"
		  marginLeft="0.5vw" // Inherits the text color from the Alert (usually white/light) for better contrast
        //   sx={{
        //     fontWeight: 'bold', // Optional: Make the link stand out a bit more
        //     // Add any other custom styles for the link if needed
        //   }}
          onClick={(event) => {
              // Optional: If clicking the link should NOT close the snackbar,
              // you might need to stop propagation depending on your setup.
              // event.stopPropagation();
              console.log("Help link clicked!");
            }}
        >
          Request Access{/* 3. Your desired link text */}
        </Link>
					</Typography>
				</Box>
				<Box
					sx={{
						position: "absolute",
						bottom: "10px",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Typography fontSize="14px" color="#666666">
						© 2025 All rights with Searce
					</Typography>
				</Box>
			</Grid>
		</Grid>
	);
};

export default LoginPage;
